import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Translate,
  Buildings,
  Clock,
  Users,
  Calendar,
  WhatsappLogo,
  CheckCircle,
} from "@phosphor-icons/react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import { openWhatsapp } from "../lib/whatsapp";

export default function Batches() {
  return (
    <div
      data-testid="batches-root"
      className="min-h-screen bg-[#F4F3ED] text-[#0A0A0A] font-body"
    >
      <Navbar />
      <main className="pt-28 lg:pt-32 pb-16">
        <section className="px-5 lg:px-10 max-w-[1320px] mx-auto">
          <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-3">
            <Link to="/" className="hover:text-[#0A0A0A]">
              Home
            </Link>{" "}
            / New Batches
          </div>
          <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] mb-5">
            Two new batches. <br />
            <span className="text-[#D9381E]">Pick the one that fits.</span>
          </h1>
          <p className="font-body text-base lg:text-lg text-[#4A4A4A] max-w-2xl mb-12">
            Both batches teach the <strong>same complete Market Profile &amp;
            Order Flow syllabus</strong> as our flagship Pro cohort — same
            depth, same mentor, same execution framework. Only the language and
            format change.
          </p>
        </section>

        {/* ---------- ENGLISH BATCH ---------- */}
        <section
          data-testid="english-batch"
          className="px-5 lg:px-10 max-w-[1320px] mx-auto mb-10"
        >
          <div className="border border-[#0A0A0A] bg-[#0A0A0A] text-[#F4F3ED] overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="lg:col-span-8 p-8 lg:p-12">
                <div className="inline-flex items-center gap-2 bg-[#D9381E] text-white px-3 py-1.5 mb-5">
                  <Translate size={14} weight="bold" />
                  <span className="font-mono-acc text-[10px] tracking-[0.28em] uppercase">
                    By popular demand · now in English
                  </span>
                </div>

                <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#FFB703] mb-2">
                  01 · English Online Batch
                </div>
                <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter mb-4">
                  English Batch — starts{" "}
                  <span className="text-[#FFB703]">15 August 2026</span>
                </h2>
                <p className="font-body text-base lg:text-lg text-[#A1A1AA] leading-relaxed mb-6">
                  Get ready for your financial independence with our new batch{" "}
                  <strong className="text-[#F4F3ED]">fully in English</strong>.
                  Same 6-month structured mentorship as our flagship Pro cohort
                  — Market Profile foundations, Order Flow deep-dive, and the
                  Three Points execution framework. Live classes, live trading
                  support, EOD discussions.
                </p>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-7">
                  {[
                    { i: Calendar, t: "Starts 15 Aug 2026" },
                    { i: Translate, t: "100% English delivery" },
                    { i: Clock, t: "6-month curriculum" },
                  ].map(({ i: Icon, t }) => (
                    <div
                      key={t}
                      className="inline-flex items-center gap-2 border border-[#2A2A2A] px-3 py-2"
                    >
                      <Icon size={16} weight="duotone" className="text-[#D9381E]" />
                      <span className="font-mono-acc text-[10px] tracking-[0.2em] uppercase">
                        {t}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() =>
                      openWhatsapp(
                        "Hi, I'm interested in the English batch starting 15 Aug 2026. Please share details."
                      )
                    }
                    data-testid="english-batch-cta"
                    className="inline-flex items-center justify-center gap-2 bg-[#FFB703] text-[#0A0A0A] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] font-bold hover:bg-[#F4F3ED] transition-colors"
                  >
                    <WhatsappLogo size={16} weight="fill" />
                    Reserve English batch seat
                  </button>
                  <a
                    href="/downloads/GreatEagle_Syllabus.pdf"
                    download
                    className="inline-flex items-center justify-center gap-2 border border-[#F4F3ED]/50 text-[#F4F3ED] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#F4F3ED] hover:text-[#0A0A0A] transition-colors"
                  >
                    ↓ Syllabus PDF
                  </a>
                </div>
              </div>
              <div className="lg:col-span-4 bg-gradient-to-br from-[#D9381E]/15 via-[#0A0A0A] to-[#0A0A0A] p-8 lg:p-12 border-t lg:border-t-0 lg:border-l border-[#F4F3ED]/10">
                <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-4">
                  Perfect if you
                </div>
                <ul className="space-y-3">
                  {[
                    "Prefer English delivery over Hindi/regional mix",
                    "Are based outside South India",
                    "Want the full 6-month structured mentorship",
                    "Want live sessions + practical PnL audits",
                  ].map((t) => (
                    <li
                      key={t}
                      className="flex items-start gap-3 font-body text-sm"
                    >
                      <CheckCircle
                        size={18}
                        weight="fill"
                        className="text-[#FFB703] shrink-0 mt-0.5"
                      />
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ---------- OFFLINE BATCH ---------- */}
        <section
          data-testid="offline-batch"
          className="px-5 lg:px-10 max-w-[1320px] mx-auto"
        >
          <div className="border border-[#0A0A0A] bg-[#F4F3ED] text-[#0A0A0A]">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="lg:col-span-8 p-8 lg:p-12">
                <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-[#FFB703] px-3 py-1.5 mb-5">
                  <Buildings size={14} weight="bold" />
                  <span className="font-mono-acc text-[10px] tracking-[0.28em] uppercase">
                    Classroom · Max 8 seats
                  </span>
                </div>

                <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-2">
                  02 · Offline Immersion Batch
                </div>
                <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter mb-4">
                  15-day <span className="text-[#D9381E]">classroom</span>{" "}
                  intensive.
                </h2>
                <p className="font-body text-base lg:text-lg text-[#4A4A4A] leading-relaxed mb-6">
                  Fifteen straight <strong>Monday-to-Friday</strong> days of
                  in-classroom immersion during live market hours — followed by{" "}
                  <strong>6 months of online support</strong> so your learning
                  never stops. The same full syllabus, compressed into a
                  hands-on classroom experience.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-7">
                  {[
                    { i: Calendar, t: "15 days · Mon → Fri, consecutive" },
                    { i: Clock, t: "Report at classroom by 8:45 AM sharp" },
                    { i: Clock, t: "Evening class 4:00 – 6:00 PM" },
                    { i: Users, t: "Maximum 8 seats per batch" },
                    { i: Buildings, t: "Live market hours in-person" },
                    { i: CheckCircle, t: "+ 6 months online support" },
                  ].map(({ i: Icon, t }, idx) => (
                    <div
                      key={idx}
                      className="inline-flex items-center gap-2.5 border border-[#0A0A0A] px-3 py-2.5"
                    >
                      <Icon size={16} weight="duotone" className="text-[#D9381E]" />
                      <span className="font-body text-[13px]">{t}</span>
                    </div>
                  ))}
                </div>

                <div className="border-l-4 border-[#D9381E] pl-4 mb-7 bg-[#FFF6E0]/40 py-3">
                  <div className="font-mono-acc text-[10px] tracking-[0.28em] uppercase text-[#D9381E] mb-1">
                    A typical day
                  </div>
                  <p className="font-body text-sm text-[#4A4A4A] leading-relaxed">
                    Arrive by <strong>8:45 AM</strong> → live-market classroom
                    (9:15 AM onwards, watching the auction unfold in real time)
                    → structured teaching session in the{" "}
                    <strong>evening 4:00 – 6:00 PM</strong>. Every module of
                    the flagship curriculum, delivered face-to-face.
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() =>
                      openWhatsapp(
                        "Hi, I'm interested in the 15-day OFFLINE classroom batch (max 8 seats). Please share dates & fees."
                      )
                    }
                    data-testid="offline-batch-cta"
                    className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-[#F4F3ED] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] font-bold hover:bg-[#D9381E] transition-colors"
                  >
                    <WhatsappLogo size={16} weight="fill" />
                    Reserve offline seat
                  </button>
                  <a
                    href="/downloads/GreatEagle_Syllabus.pdf"
                    download
                    className="inline-flex items-center justify-center gap-2 border border-[#0A0A0A] text-[#0A0A0A] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#0A0A0A] hover:text-[#F4F3ED] transition-colors"
                  >
                    ↓ Syllabus PDF
                  </a>
                </div>
              </div>
              <div className="lg:col-span-4 bg-gradient-to-br from-[#EAE8DF] to-[#F4F3ED] p-8 lg:p-12 border-t lg:border-t-0 lg:border-l border-[#0A0A0A]/10">
                <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-4">
                  Why offline?
                </div>
                <ul className="space-y-3">
                  {[
                    "Complete distraction-free immersion",
                    "Watch the auction unfold in a live room, together",
                    "Small class (max 8) → real 1-on-1 attention",
                    "Same 6-month online support included",
                    "Faster progression — 15 straight days > months",
                  ].map((t) => (
                    <li
                      key={t}
                      className="flex items-start gap-3 font-body text-sm"
                    >
                      <CheckCircle
                        size={18}
                        weight="fill"
                        className="text-[#D9381E] shrink-0 mt-0.5"
                      />
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ---------- Not sure? ---------- */}
        <section className="px-5 lg:px-10 max-w-[1320px] mx-auto mt-12">
          <div className="border border-[#0A0A0A] p-6 lg:p-8 bg-[#EAE8DF] flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-1">
                Still deciding?
              </div>
              <div className="font-display font-black text-xl lg:text-2xl tracking-tight">
                Try our ecosystem before you commit.
              </div>
            </div>
            <Link
              to="/decide"
              data-testid="batches-to-decide"
              className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-[#F4F3ED] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#D9381E] transition-colors whitespace-nowrap"
            >
              Try before you commit <ArrowRight size={14} weight="bold" />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
